module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE5LjE3OCAxMi45MzNsLTEwLjY4IDEwLjY4YTEuMzE5IDEuMzE5IDAgMCAxLTEuODY2IDBsLTEuMjQ2LTEuMjQ1YTEuMzE5IDEuMzE5IDAgMCAxLS4wMDItMS44NjNMMTMuODUgMTIgNS4zODQgMy40OTVhMS4zMTkgMS4zMTkgMCAwIDEgLjAwMi0xLjg2M0w2LjYzMi4zODZhMS4zMTkgMS4zMTkgMCAwIDEgMS44NjUgMGwxMC42ODEgMTAuNjgxYy41MTYuNTE1LjUxNiAxLjM1IDAgMS44NjZ6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right-smooth.svg
// module id = e3Yf
// module chunks = 10